<template>
  <div>
    <div class="people-list" id="people-list">
      <div class="desktopView">
        <el-input
          class="gadget"
          v-model="search"
          slot="prepend"
          placeholder="搜索已聊用户"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <ul class="list">
          <li
            v-for="conversation in filterUser()"
            :class="isActive(conversation) ? 'clearfix active' : 'clearfix'"
            :index="conversation.id"
            :key="conversation.id"
            @click="goToConversation(conversation)"
          >
            <EachConversationPreview
              :conversation="conversation"
            ></EachConversationPreview>
          </li>
        </ul>
      </div>
      <div class="mobileView convDropdown">
        <el-select v-model="talkToId" placeholder="选择用户">
          <el-option
            v-for="conversation in filterUser()"
            :key="conversation.talkTo.id"
            :label="'当前聊天用户：' + conversation.talkTo.name"
            :value="conversation.talkTo.id.toString()"
          >
            <EachConversationPreview
              :conversation="conversation"
            ></EachConversationPreview>
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import Event from "../../event.js";
import { mapState } from "vuex";
import EachConversationPreview from "./EachConversationPreview";
export default {
  components: { EachConversationPreview },
  data: function() {
    return {
      conversations: [],
      talkToId: "",
      search: ""
    };
  },
  computed: {
    ...mapState(["user"])
  },
  watch: {
    talkToId: function(newVal) {
      for (var i = 0; i < this.conversations.length; i++) {
        if (this.conversations[i].talkTo.id.toString() === newVal) {
          this.goToConversation(this.conversations[i]);
        }
      }
    }
  },
  methods: {
    filterUser() {
      return this.conversations
        .filter(conv => {
          return (
            conv.talkTo.name.toLowerCase().indexOf(this.search.toLowerCase()) >
            -1
          );
        })
        .sort((a, b) => {
          if (a.last_message === null) {
            if (b.last_message === null) {
              return a.created_at > b.created_at ? -1 : 1;
            }
            return 1;
          }
          // a's last message not null , b's last message is null
          if (b.last_message === null) {
            return -1;
          } else {
            // a's last message not null, b's last message not null
            return a.last_message.created_at > b.last_message.created_at
              ? -1
              : 1;
          }
          //(a.last_message === null || b.last_message === null)? (a.created_at > b.created_at? 1: -1) : (a.last_message.created_at > b.last_message.created_at? 1: -1)
        });
    },
    isActive(conversation) {
      return conversation.talkTo.id == this.$route.query.id;
    },
    isMine(senderId) {
      return this.user.id === senderId;
    },
    fetchConversations: function() {
      this.$http.get(`/conversations`).then(res => {
        this.conversations = res.data.data;
      });
    },
    goToConversation(conversation) {
      this.$router.push({
        path: "/messages",
        query: { id: conversation.talkTo.id }
      });
    }
  },
  mounted() {
    this.talkToId = this.$route.query.id;
    // listen to new messages
    Event.$on("conversation.mark.read", conversation => {
      var totalMessageCount = 0;
      for (var i = 0; i < this.conversations.length; i++) {
        if (this.conversations[i].id === conversation.id) {
          this.conversations[i].unread_count = 0;
        }
        totalMessageCount += this.conversations[i].unread_count;
      }
      this.user.message_count = totalMessageCount;
    });
    Event.$on("message.received", message => {
      var i = 0;
      for (i = 0; i < this.conversations.length; i++) {
        // loop through the conversations to add the count to the specific conversation
        if (this.conversations[i].id === message.conversation_id) {
          this.conversations[i].last_message = message;
          if (!this.isMine(message.user_id)) {
            // if it's not my own message
            this.conversations[i].unread_count++;
          }
          break;
        }
      }

      if (i === this.conversations.length) {
        this.fetchConversations();
      }
    });
    //fetch conversations
    this.fetchConversations();
  }
};
</script>
<style scoped>
.people-list {
  font-size: 10px;
  width: 100%;
  padding: 20px;
}
.people-list li {
  padding: 10px;
  border-radius: 5px;
}

.people-list li.active {
  background: #00896b;
  color: white;
}
.people-list li:hover {
  background: #00c851;
  color: white;
}
.people-list ul {
  padding: 0;
  list-style-type: none;
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
</style>
